import { render } from "./AboutUs.vue?vue&type=template&id=23a2ec4e&scoped=true&lang=pug"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23a2ec4e"

export default script